;(function(){
  'use strict';

  if(window.__SHProductReviewPriorityV115)return;
  window.__SHProductReviewPriorityV115=true;

  var ROOT='[data-sh-full-reviews-app]';
  var CARD='.alr-wh-comp-review-item-list';
  var TEXT='.alr-wh-comp-text-content';
  var NATIVE='.alr-wh-comp-review-listing:not(.sh-review-priority-mirror)';
  var marketplace=/\b(?:ali\s*express|alibaba|temu|shein|amazon|ebay|wish|dhgate|taobao|marketplace|seller|supplier|vendor|merchant|china\s+warehouse)\b/i;
  var generic=/^(?:very\s+)?(?:good|great|nice|perfect|beautiful|excellent|amazing|awesome|love\s+it|i\s+love\s+it|as\s+described|thank\s+you|thanks|ok|okay|recommended|fast\s+shipping|arrived\s+quickly|good\s+product|great\s+product|nice\s+product)[.!\s]*$/i;
  var detailTerms=/\b(?:room|bedroom|living|desk|table|shelf|wall|light|lamp|colour|color|shade|brightness|bright|dim|size|small|large|quality|material|glass|metal|wood|ceramic|fabric|finish|texture|button|switch|battery|charge|cable|plug|timer|mist|diffuser|oil|assemble|assembly|instructions|packaging|packed|use|using|works|look|looks|feel|feels|fit|fits|sturdy|soft|comfortable|warm|gift)\b/gi;
  var INITIAL_REVIEW_COUNT=(window.matchMedia&&window.matchMedia("(min-width:1024px)").matches)?4:3;
  var timers=[];

  function qsa(selector,root){return Array.prototype.slice.call((root||document).querySelectorAll(selector));}
  function clean(value){return(value||'').replace(/\s+/g,' ').trim();}
  function normalise(value){return clean(value).toLowerCase().replace(/https?:\/\/\S+/g,' ').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();}
  function body(card){var node=card.querySelector(TEXT);return clean(node?node.textContent:'');}
  function id(card){var node=card.querySelector(TEXT);return(node&&node.getAttribute('data-alr-id'))||normalise(body(card));}
  function rating(card){var node=card.querySelector('[data-star]');var value=node?parseFloat(node.getAttribute('data-star')):0;return isFinite(value)?value:0;}

  function hasMedia(card){
    if(qsa('img,video',card).some(function(node){return !node.closest('.alr-wh-comp-review-avatar,.alr-wh-comp-review-account-flag-date-wrap,[class*="rating"]');}))return true;
    return qsa('[class*="media"],[class*="photo"],[class*="video"],[class*="attachment"]',card).some(function(node){
      var name=typeof node.className==='string'?node.className:'';
      return !/avatar|flag|rating/i.test(name)&&(!!node.querySelector('img,video')||/background-image\s*:/i.test(node.getAttribute('style')||''));
    });
  }

  function signals(text){
    var words=text.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9']+/g)||[];
    var unique={};words.forEach(function(word){if(word.length>2)unique[word.toLowerCase()]=true;});
    var alpha=(text.match(/[A-Za-zÀ-ÖØ-öø-ÿ]/g)||[]).length;
    var details={};(text.match(detailTerms)||[]).forEach(function(term){details[term.toLowerCase()]=true;});
    return {words:words.length,uniqueRatio:words.length?Object.keys(unique).length/words.length:0,alphaRatio:alpha/((text.match(/\S/g)||[]).length||1),sentences:(text.match(/[.!?](?:\s|$)/g)||[]).length,details:Object.keys(details).length};
  }

  function assess(card){
    var text=body(card),norm=normalise(text),s=signals(text),media=hasMedia(card);
    var banned=marketplace.test(text);
    var poor=!norm||generic.test(text)||text.length<32||s.words<6||s.alphaRatio<.58||(s.words<=8&&s.details<2)||(s.words<12&&s.details===0)||(s.words>7&&s.uniqueRatio<.38);
    var written=!poor&&text.length>=70&&s.words>=13&&(s.sentences>=2||s.details>=2);
    var tier=written&&media?3:written?2:media?1:0;
    var quality=Math.min(s.words,80)*5+s.sentences*24+s.details*30+Math.round(s.uniqueRatio*90)+Math.round(rating(card)*6);
    if(s.words>180)quality-=Math.min(s.words-180,100);
    if(/[.!?]/.test(text))quality+=18;
    if(/\b(?:because|although|however|while|after|before|when|which|but|and)\b/i.test(text))quality+=24;
    if(/[A-Z]{8,}/.test(text))quality-=60;
    return {card:card,key:id(card),norm:norm,hidden:banned||poor,tier:tier,score:tier*10000+quality};
  }

  function tune(){
    var settings=window.__AR_WIDGET_REVIEW_BOX_SETTING;
    if(!settings)return;
    settings.default_reviews_sorting='by_media';
    settings.show_review_media=true;
    settings.show_media_section=true;
    settings.enable_auto_play=false;
    settings.enable_infinite_loop=false;
  }

  function setAvailability(root,status){
    if(root.getAttribute('data-sh-review-enabled')==='false')status='empty';
    root.setAttribute('data-sh-review-availability',status);
    root.setAttribute('aria-hidden',status==='ready'?'false':'true');
  }

  function clearEmptyTimer(root){
    if(!root.__shReviewEmptyTimer)return;
    window.clearTimeout(root.__shReviewEmptyTimer);
    root.__shReviewEmptyTimer=null;
  }

  function scheduleEmpty(root){
    if(root.getAttribute('data-sh-review-enabled')==='false'){
      setAvailability(root,'empty');
      return;
    }
    if(root.__shReviewEmptyTimer)return;
    setAvailability(root,'pending');
    root.__shReviewEmptyTimer=window.setTimeout(function(){
      root.__shReviewEmptyTimer=null;
      var nativeList=root.querySelector(NATIVE);
      var cards=nativeList?qsa(CARD,nativeList):[];
      if(cards.length){
        setAvailability(root,'ready');
        schedule(root);
      }else{
        setAvailability(root,'empty');
      }
    },5000);
  }

  function prepareClone(item){
    var clone=item.card.cloneNode(true);
    clone.classList.remove('sh-review-priority-hidden');
    clone.setAttribute('data-sh-review-priority',String(item.tier));
    clone.removeAttribute('aria-hidden');
    qsa('[id]',clone).forEach(function(node){node.removeAttribute('id');});
    qsa('img',clone).forEach(function(image){
      prepareImage(image,imageSource(image));
    });
    return clone;
  }

  function imageSource(image){
    var candidates=[image.getAttribute('alr-origin-src'),image.getAttribute('data-src'),image.getAttribute('data-lazy-src'),image.getAttribute('alt'),image.currentSrc,image.getAttribute('src'),image.src];
    for(var i=0;i<candidates.length;i++)if(candidates[i]&&/^https?:\/\//i.test(candidates[i]))return candidates[i];
    return '';
  }

  function resizeImage(source){
    if(!source)return '';
    try{
      var parsed=new URL(source,window.location.href);
      if(/imgs\.alireviews\.io$/i.test(parsed.hostname)&&/\/images\/resize/i.test(parsed.pathname)){
        return source.match(/([?&])width=\d+/i)?source.replace(/([?&])width=\d+/i,'$1width=480'):source+'&width=480';
      }
      if(/(?:alicdn\.com|aliexpress-media\.com)$/i.test(parsed.hostname))return 'https://imgs.alireviews.io/images/resize?url='+source+'&width=480';
    }catch(error){}
    return source;
  }

  function prepareImage(image,source){
    if(!image)return;
    var alt=image.getAttribute('alt')||'';
    if(/^https?:\/\//i.test(alt))image.setAttribute('alt','Customer review photo');
    var original=source;
    if(image.getAttribute('data-sh-media-original')!==original){
      image.setAttribute('data-sh-media-original',original||'');
      image.removeAttribute('data-sh-media-fallback');
    }
    var requested=image.hasAttribute('data-sh-media-fallback')?original:resizeImage(original);
    var changed=!!requested&&image.getAttribute('src')!==requested;
    if(changed){
      image.removeAttribute('srcset');
      image.setAttribute('src',requested);
    }
    image.setAttribute('loading','eager');
    image.setAttribute('decoding','async');
    if(changed||!image.classList.contains('sh-review-media-ready'))image.style.opacity='0';
    var ready=function(){
      if(image.naturalWidth>0){
        image.classList.add('sh-review-media-ready');
        image.style.opacity='1';
        var holder=image.closest('.alr-wh-comp-image-lazy-load');
        if(holder)holder.classList.add('alr-wh-image-loaded','sh-review-media-loaded');
      }
    };
    if(!image.__shMediaReady){
      image.__shMediaReady=true;
      image.addEventListener('load',ready);
      image.addEventListener('error',function(){
        var fallback=image.getAttribute('data-sh-media-original')||'';
        if(fallback&&!image.hasAttribute('data-sh-media-fallback')&&image.getAttribute('src')!==fallback){
          image.setAttribute('data-sh-media-fallback','true');
          image.setAttribute('src',fallback);
        }
      });
    }
    if(image.complete)ready();
  }

  function openNativeImage(event,state){
    var displayed=event.target.closest&&event.target.closest('.alr-wh-comp-review-image');
    if(!displayed||!state.mirror.contains(displayed))return;
    var displayedCard=displayed.closest(CARD);
    if(!displayedCard)return;
    var sourceCard=qsa(CARD,state.nativeList).filter(function(card){return id(card)===id(displayedCard);})[0];
    if(!sourceCard)return;
    var displayedMedia=qsa('.alr-wh-comp-review-image',displayedCard);
    var sourceMedia=qsa('.alr-wh-comp-review-image',sourceCard);
    var index=displayedMedia.indexOf(displayed);
    var sourceTarget=sourceMedia[index];
    if(!sourceTarget)return;
    event.preventDefault();
    event.stopPropagation();
    sourceTarget.click();
  }

  function copyMediaNode(source,target){
    if(!source||!target)return;
    ['sizes','poster'].forEach(function(attribute){
      var value=source.getAttribute(attribute);
      if(value)target.setAttribute(attribute,value);
    });
    var sourceStyle=window.getComputedStyle(source);
    if(sourceStyle.backgroundImage&&sourceStyle.backgroundImage!=='none')target.style.backgroundImage=sourceStyle.backgroundImage;
    if(target.tagName==='IMG'){
      prepareImage(target,imageSource(source));
      target.removeAttribute('hidden');
    }else{
      var mediaSource=source.getAttribute('src')||source.currentSrc||source.src||'';
      if(mediaSource)target.setAttribute('src',mediaSource);
    }
  }

  function syncMedia(root,state,nativeList){
    if(!state||!state.mirror||!nativeList)return;
    var nativeById={};
    qsa(CARD,nativeList).forEach(function(card){nativeById[id(card)]=card;});
    qsa(CARD,state.mirror).forEach(function(mirrorCard){
      var sourceCard=nativeById[id(mirrorCard)];
      if(!sourceCard)return;
      var sourceMedia=qsa('img,video,source',sourceCard);
      var targetMedia=qsa('img,video,source',mirrorCard);
      sourceMedia.forEach(function(source,index){copyMediaNode(source,targetMedia[index]);});
      var sourceBackgrounds=qsa('[style*="background"]',sourceCard);
      var targetBackgrounds=qsa('[style*="background"]',mirrorCard);
      sourceBackgrounds.forEach(function(source,index){
        var target=targetBackgrounds[index];
        if(!target)return;
        var image=window.getComputedStyle(source).backgroundImage;
        if(image&&image!=='none')target.style.backgroundImage=image;
      });
    });
  }

  function scheduleMedia(root,state,nativeList){
    window.clearTimeout(state.mediaTimer);
    state.mediaTimer=window.setTimeout(function(){syncMedia(root,state,nativeList);},60);
  }

  function createMirror(root,state,nativeList){
    var mirror=document.createElement('div');
    mirror.className='alr-wh-comp-review-listing sh-review-priority-mirror';
    mirror.setAttribute('aria-live','polite');
    mirror.setAttribute('aria-hidden','true');
    nativeList.parentNode.insertBefore(mirror,nativeList);
    mirror.addEventListener('click',function(event){openNativeImage(event,state);});
    mirror.addEventListener('keydown',function(event){
      if(event.key==='Enter'||event.key===' '){
        var image=event.target.closest&&event.target.closest('.alr-wh-comp-review-image');
        if(image){event.preventDefault();image.click();}
      }
    });
    if(!root.__shPriorityLoadListener){
      root.__shPriorityLoadListener=true;
      root.addEventListener('click',function(event){
        var control=event.target.closest&&event.target.closest('button,a,[role="button"]');
        if(!control||control.closest('.sh-review-priority-mirror')||!/^load\s+more(?:\s+reviews)?\b/i.test(clean(control.textContent)))return;
        var current=root.__shPriorityMirror;
        if(current&&event.isTrusted)current.visibleLimit=(current.visibleLimit||INITIAL_REVIEW_COUNT)+INITIAL_REVIEW_COUNT;
      },true);
    }
    state.mirror=mirror;
    state.signature='';
  }

  function observeNative(root,state,nativeList){
    if(state.mediaObserver)state.mediaObserver.disconnect();
    state.nativeList=nativeList;
    nativeList.setAttribute('aria-hidden','false');
    state.mediaObserver=new MutationObserver(function(){scheduleMedia(root,state,state.nativeList);});
    state.mediaObserver.observe(nativeList,{attributes:true,attributeFilter:['src','srcset','sizes','poster','style','alr-origin-src','data-src','data-lazy-src'],childList:true,subtree:true});
    state.signature='';
  }

  function ensureState(root,nativeList){
    var state=root.__shPriorityMirror;
    if(!state){
      state=root.__shPriorityMirror={mirror:null,nativeList:null,signature:'',mediaObserver:null,autoLoadPending:false,autoLoadAttempts:0,lastAutoLoadCount:-1,visibleLimit:INITIAL_REVIEW_COUNT};
    }
    if(state.nativeList!==nativeList)observeNative(root,state,nativeList);
    if(!state.mirror||!state.mirror.isConnected||state.mirror.parentNode!==nativeList.parentNode){
      if(state.mirror&&state.mirror.parentNode)state.mirror.parentNode.removeChild(state.mirror);
      createMirror(root,state,nativeList);
    }
    return state;
  }

  function findLoadMore(root){
    return qsa('button,a,[role="button"]',root).filter(function(control){
      if(control.closest&&control.closest('.sh-review-priority-mirror'))return false;
      if(control.disabled||control.getAttribute('aria-disabled')==='true')return false;
      return /^load\s+more(?:\s+reviews)?\b/i.test(clean(control.textContent));
    })[0]||null;
  }

  function ensureInitialCount(root,state,nativeCount,visibleCount){
    if(visibleCount>=INITIAL_REVIEW_COUNT){state.autoLoadPending=false;return;}
    if(state.autoLoadPending||state.autoLoadAttempts>=5)return;
    var control=findLoadMore(root);
    if(!control)return;
    if(state.lastAutoLoadCount===nativeCount&&state.autoLoadAttempts>0)return;
    state.autoLoadPending=true;
    state.autoLoadAttempts+=1;
    state.lastAutoLoadCount=nativeCount;
    window.setTimeout(function(){
      control.click();
      window.setTimeout(function(){state.autoLoadPending=false;schedule(root);},900);
    },40);
  }

  function renderAll(root,state,cards){
    if(!cards.length||cards.some(function(card){return !body(card);})){return false;}
    var items=cards.map(assess);
    var seenIds={},seenNorms={};
    items.forEach(function(item){
      if(seenIds[item.key]||seenNorms[item.norm])item.hidden=true;
      seenIds[item.key]=true;
      if(item.norm)seenNorms[item.norm]=true;
    });
    items.sort(function(a,b){if(a.hidden!==b.hidden)return a.hidden?1:-1;return b.score-a.score;});
    var visible=items.filter(function(item){return !item.hidden;});
    if(!visible.length){
      state.mirror.replaceChildren();
      state.mirror.setAttribute('aria-hidden','true');
      state.nativeList.setAttribute('aria-hidden','false');
      root.removeAttribute('data-sh-review-priority-active');
      root.removeAttribute('data-sh-review-priority-ready');
      setAvailability(root,'ready');
      return false;
    }
    var existing={};
    qsa(CARD,state.mirror).forEach(function(card){existing[id(card)]=card;});
    var fragment=document.createDocumentFragment();
    visible.slice(0,state.visibleLimit||INITIAL_REVIEW_COUNT).forEach(function(item){
      var card=existing[item.key]||prepareClone(item);
      card.setAttribute('data-sh-review-priority',String(item.tier));
      fragment.appendChild(card);
    });
    state.mirror.replaceChildren(fragment);
    state.signature=cards.map(id).join('|');
    state.mirror.setAttribute('aria-hidden','false');
    state.nativeList.setAttribute('aria-hidden','true');
    root.setAttribute('data-sh-review-priority-active','true');
    root.setAttribute('data-sh-review-priority-ready','true');
    setAvailability(root,'ready');
    ensureInitialCount(root,state,cards.length,visible.length);
    return true;
  }

  function update(root){
    tune();
    var nativeList=root.querySelector(NATIVE);
    if(!nativeList){
      root.removeAttribute('data-sh-review-priority-active');
      root.removeAttribute('data-sh-review-priority-ready');
      scheduleEmpty(root);
      return;
    }
    nativeList.classList.add('sh-review-priority-native');
    var state=ensureState(root,nativeList);
    var cards=qsa(CARD,nativeList);
    if(cards.length){
      clearEmptyTimer(root);
      setAvailability(root,'ready');
    }else{
      scheduleEmpty(root);
    }
    var signature=cards.map(id).join('|');
    var rendered=signature===state.signature&&root.getAttribute('data-sh-review-priority-ready')==='true';
    if(signature!==state.signature)rendered=renderAll(root,state,cards);
    if(rendered)syncMedia(root,state,nativeList);
  }

  function schedule(root){
    if(!root)return;
    window.clearTimeout(root.__shPriorityTimer);
    root.__shPriorityTimer=window.setTimeout(function(){update(root);},420);
  }

  function scan(){
    tune();
    qsa(ROOT).forEach(schedule);
  }

  var observer=new MutationObserver(function(records){
    var roots=[];
    records.forEach(function(record){
      var node=record.target&&record.target.nodeType===1?record.target:record.target.parentElement;
      var root=node&&node.closest?node.closest(ROOT):null;
      if(root&&roots.indexOf(root)<0)roots.push(root);
    });
    roots.forEach(function(root){
      var state=root.__shPriorityMirror;
      var nativeList=root.querySelector(NATIVE);
      var stale=state&&nativeList&&(!state.mirror||!state.mirror.isConnected||state.nativeList!==nativeList);
      if(stale){
        window.clearTimeout(root.__shPriorityTimer);
        update(root);
      }else{
        schedule(root);
      }
    });
  });
  observer.observe(document.documentElement,{childList:true,characterData:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  window.addEventListener('load',scan,{once:true});
  window.addEventListener('scroll',function(){
    qsa(ROOT).forEach(function(root){
      var state=root.__shPriorityMirror;
      var nativeList=root.querySelector(NATIVE);
      if(state&&nativeList)scheduleMedia(root,state,nativeList);
    });
  },{passive:true});
  document.addEventListener('shopify:section:load',scan);
  [0,250,750,1500,3000].forEach(function(delay){timers.push(window.setTimeout(scan,delay));});
})();
